// extracted by mini-css-extract-plugin
export default {"modeloTableContainer":"ModeloTable_modeloTableContainer__oYF80","modeloTableTitle":"ModeloTable_modeloTableTitle__MUoax","modeloSpecsTable":"ModeloTable_modeloSpecsTable__kHvSg"};